<script setup>
import { computed } from 'vue'
import { nativeDateTimeInput, nativeDateTimeInstant } from '../../dateTime/historyDateTime.js'
import NativeDateTimeField from '../shared/NativeDateTimeField.vue'
import { useI18n } from '../../i18n.js'

const { t } = useI18n()

const model = defineModel({ type: Object, required: true })
const props = defineProps({
  sources: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  rangeError: { type: String, default: '' },
  showSource: { type: Boolean, default: true },
  fromLabel: { type: String, default: '' },
  toLabel: { type: String, default: '' },
  includeSeconds: { type: Boolean, default: false },
  inclusiveEnd: { type: Boolean, default: false },
  rangeErrorId: { type: String, default: 'pts2-history-range-error' },
})

const sourceDisabled = computed(() => props.loading || !props.sources.length)

function localInput(value, field) {
  return nativeDateTimeInput(value, { includeSeconds: props.includeSeconds, inclusiveEnd: field === 'to' && props.inclusiveEnd })
}

function update(field, value) {
  model.value = { ...model.value, [field]: value }
}

function setLocal(field, value) {
  update(field, nativeDateTimeInstant(value, { inclusiveEnd: field === 'to' && props.inclusiveEnd }))
}

function sourceLabel(source) {
  return source.stableCode || source.displayName || t('pts2UiHistoryControllerNumber', { number: source.id })
}
</script>

<template>
  <div class="pts2-history-filter-core" :class="{ 'without-source': !showSource }">
    <label v-if="showSource">
      <span>{{ t('pts2UiHistorySource') }}</span>
      <select :value="model.controllerId ?? ''" :disabled="sourceDisabled"
        :aria-label="t('pts2UiHistorySourceAccessible')" @change="update('controllerId', $event.target.value ? Number($event.target.value) : null)">
        <option value="" disabled>{{ sources.length ? t('pts2UiChoose') : t('pts2UiHistorySourcesUnavailable') }}</option>
        <option v-for="source in sources" :key="source.id" :value="source.id">{{ sourceLabel(source) }}</option>
      </select>
      <small>{{ t('pts2UiHistoryStationContext') }}</small>
    </label>
    <NativeDateTimeField :model-value="localInput(model.from, 'from')" :label="fromLabel || t('pts2UiHistoryFrom')"
      :include-seconds="includeSeconds" :disabled="loading" :invalid="Boolean(rangeError)" :error-id="rangeErrorId" @update:model-value="setLocal('from', $event)" />
    <NativeDateTimeField :model-value="localInput(model.to, 'to')" :label="toLabel || t('pts2UiHistoryTo')"
      :include-seconds="includeSeconds" :disabled="loading" :invalid="Boolean(rangeError)" :error-id="rangeErrorId" @update:model-value="setLocal('to', $event)" />
    <p v-if="rangeError" :id="rangeErrorId" class="field-error pts2-history-range-error" role="alert">{{ rangeError }}</p>
    <small class="pts2-history-apply-hint">{{ t('pts2HistoryApplyHint') }}</small>
  </div>
</template>
